import React from 'react';
import { isServer } from '@okapi/dom-utils';
import { handleBasketLoad } from './listeners/load';
import { handleBasketSetProduct } from './listeners/set_product';
import { handleBasketAddProducts } from './listeners/add_products';
import { handleBasketDeleteProducts } from './listeners/delete_products';
import { handleBasketSetService } from './listeners/set_service';
import { handleBasketSetServices } from './listeners/set_services';
import {
  BASKET_EVENT_ADD_PRODUCTS,
  BASKET_EVENT_DELETE_PRODUCTS,
  BASKET_EVENT_LOAD,
  BASKET_EVENT_SET_PRODUCT,
  BASKET_EVENT_SET_SERVICE,
  BASKET_EVENT_SET_SERVICES,
} from './consts';

export { cleanCache } from './listeners/load';
export type { BasketSetItemEventArg } from './listeners/set_product';

if (!isServer() && !window.isBasketLogicInitialized) {
  document.body.addEventListener(BASKET_EVENT_LOAD, handleBasketLoad);
  document.body.addEventListener(BASKET_EVENT_SET_PRODUCT, handleBasketSetProduct);
  document.body.addEventListener(BASKET_EVENT_ADD_PRODUCTS, handleBasketAddProducts);
  document.body.addEventListener(BASKET_EVENT_DELETE_PRODUCTS, handleBasketDeleteProducts);
  document.body.addEventListener(BASKET_EVENT_SET_SERVICE, handleBasketSetService);
  document.body.addEventListener(BASKET_EVENT_SET_SERVICES, handleBasketSetServices);
  window.isBasketLogicInitialized = true;
}

export type BasketLogicProps = {
  host?: string;
};

export const BasketLogic: React.FC<BasketLogicProps> = () => {
  return <div data-qa="basket-logic"></div>;
};
